
import Indicator from '../Indicator';

/** Average True Range indicator */
export default class AverageTrueRangeIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator Name
	 * @property {string} description - Indicator Description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'avgtruerange',
			name: 'Average True Range',
			description:
				'Average True Range is a volatility indicator that measures how much a security\'s price moves in a typical period. It differs from statistical measures like Standard Deviation in that it uses the Open, High, Low, and Closing prices to calculate the range, whereas Standard Deviation only uses closing prices.',
			inputs: [{ name: 'period', value: 14 }],
			componentSeries: [
				{ id: 'avgtruerange' }
			]
		};
	}

	/** @param {object} data - Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
